import {buildColumn, XLARGE_CELL_WIDTH} from '@eitje/web_components'
import {prettyPrintArray} from '@eitje/utils'

export const columns = [
	{accessorKey: 'partner_username', width: XLARGE_CELL_WIDTH},
	{
		accessorKey: 'emails',
		width: XLARGE_CELL_WIDTH,
		format: emails => prettyPrintArray({array: emails, quotes: false, joinWord: '&'}),
	},
	{accessorKey: 'id'},
].map(buildColumn)
